import React from "react";
import {Modal, Button} from "react-bootstrap";
import {useNavigate} from "react-router-dom";

const blockedMessages = {
    payment_failed: 'Il pagamento non è andato a buon fine. Aggiorna il metodo di pagamento per continuare.',
    payment_pending: 'Il pagamento è in attesa di conferma da PayPal.',
    suspended: 'Il tuo account è stato sospeso.',
    expired: 'Il tuo abbonamento è scaduto.',
    canceled: 'Il tuo abbonamento è stato cancellato.',
    unknown: 'C\'è un problema con il tuo account.',
};

const BlockedAccountModal = ({show, blockedReason, supportEmail, onLogout}) => {
    const navigate = useNavigate();

    const handleManageSubscription = () => {
        navigate('/gestisci-abbonamento');
    };

    return (
        <Modal show={show} backdrop="static" keyboard={false} centered>
            <Modal.Header>
                <Modal.Title>Attenzione</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center py-4">
                <p className="fs-5 mb-4">
                    {blockedMessages[blockedReason] || blockedMessages.unknown}
                </p>
                <div className="d-flex flex-column gap-2">
                    <Button className="bkg-primary border-0 fw-bold py-2" onClick={handleManageSubscription}>
                        Gestisci abbonamento
                    </Button>
                    <Button className="bg-secondary border-0 py-2" onClick={onLogout}>
                        Esci
                    </Button>
                    <a href={`mailto:${supportEmail || 'info@appmyteam.it'}`} className="mt-2 text-decoration-none">
                        Contatta l'assistenza
                    </a>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default BlockedAccountModal;
